import "./index.scss";
import React, { useState } from "react";
import { useSelector } from "react-redux";

import {
  selectIsSold,
  selectLoadingStatus,
  selectSellingStatus,
} from "../../store/features/auctionSlice";
import { Avatar, money } from "../atoms";

// The centre of the room: the photograph, and under it the one number
// everybody is watching. The three outcomes each get their own tint, and
// nothing else on the page is allowed a colour that strong.
const PlayerBid = ({ player }) => {
  const [broken, setBroken] = useState(false);

  const isSold = useSelector(selectIsSold);
  const sellingStatus = useSelector(selectSellingStatus);
  const loadingStatus = useSelector(selectLoadingStatus);

  const src = player?.image && !broken ? player.image : null;

  // Prefixed: a bare "live" or "sold" is the sort of class name another
  // stylesheet in this app already uses for something else.
  const state = isSold
    ? "is-sold"
    : sellingStatus === "unsold"
    ? "is-unsold"
    : "is-live";

  const caption =
    state === "is-sold"
      ? "Sold for"
      : state === "is-unsold"
      ? "Unsold"
      : "Current bid";

  return (
    <section className={`bid-stage ${state}`}>
      <div className="bid-stage-photo">
        {src ? (
          <img src={src} alt="" onError={() => setBroken(true)} />
        ) : (
          // Most players have no photograph on file, so this is the common
          // case rather than the edge one. Initials on the tint the name maps
          // to read as a stand-in; the blank white rectangle that used to be
          // here read as a picture that had failed to load.
          <Avatar name={player?.name} size={116} />
        )}
      </div>

      <div className="bid-stage-figure">
        <span className="au-label bid-stage-caption">{caption}</span>
        {state !== "is-unsold" && (
          <span className="bid-stage-value">
            {loadingStatus === "fetching" ? "—" : money(player?.currentBid)}
          </span>
        )}
      </div>
    </section>
  );
};

export default PlayerBid;
